import { B2B_ACCOUNT_PAGE_LINKS, B2C_ACCOUNT_PAGE_LINKS } from '@intigral/constant';
import { __ } from '../../../translations';

export const isStaticItem = (item) => {
    return item.isStatic === true;
};

export const transformStaticItem = (item, language) => {
    const staticImage = item.imageUrls[0];
    return {
        url: item?.url,
        title: '',
        caption: '',
        poster: language === 'ar' ? staticImage?.urlAr || staticImage?.url || '' : staticImage?.url || '',
        logo: '',
        guid: [],
        isStatic: true,
        bannerType: item.bannerType,
        subscriptionGuid: item.subscriptionGuid,
    };
};

export const transformStaticCarouselItem = (item) => ({
    mainImage: item.poster,
    url: item.url,
    isStatic: true,
    bannerType: item.bannerType as 'static',
    subscriptionGuid: item.subscriptionGuid,
});

export const getFilteredAddons = (configuredAddonsList, currentTierAddons, operator, language) => {
    const filteredAddons = configuredAddonsList.filter((item) => {
        const operators =
            item?.allowedOperators?.length > 0 ? item.allowedOperators?.map((op) => op.toLowerCase()) : [];
        const isCurrentTierAddon = currentTierAddons?.some((el) => el.subscriptionGUID === item.subscriptionGuid);
        const hasValidImages = item.imageUrls?.some(
            (img) =>
                (img.key === 'background' && (img.url || (language === 'ar' ? img.urlAr : img.url))) ||
                (img.key === 'title' && (img.url || (language === 'ar' ? img.urlAr : img.url)))
        );
        return (
            hasValidImages &&
            (isCurrentTierAddon || item?.isStatic) &&
            (operators.length === 0 || operators.includes(operator?.toLowerCase()))
        );
    });
    return filteredAddons;
};

export const getSubscrebedFreeAddons = (activeSubscribedAddons, currentTierAddons) => {
    const subscribedFreeAddons = activeSubscribedAddons?.filter((item1) =>
        currentTierAddons?.some(
            (item2) =>
                item2?.subscriptionGUID === item1?.subscriptionGuid && item2?.serviceCollectionId && item2?.isSubscribed
        )
    );
    return subscribedFreeAddons;
};

export const getSubscrebedPaidAddons = (activeSubscribedAddons, currentTierAddons) => {
    const subscribedFreeAddons = activeSubscribedAddons?.filter((item1) =>
        currentTierAddons?.some(
            (item2) =>
                item2?.subscriptionGUID === item1?.subscriptionGuid &&
                !item2?.serviceCollectionId &&
                item2?.isSubscribed
        )
    );
    return subscribedFreeAddons;
};

export const getManageAddonsLink = (configuration, language, operator) => {
    let redirectUrl = '';
    const baseUrl = language === 'en' ? configuration?.pickAndChoose?.urls?.en : configuration?.pickAndChoose?.urls?.ar;
    if (configuration?.pickAndChoose?.allowedOperators?.includes(operator)) {
        redirectUrl = baseUrl + `#${B2B_ACCOUNT_PAGE_LINKS.MANAGE_ADDON_LINK}`;
    } else {
        redirectUrl = baseUrl + `#${B2C_ACCOUNT_PAGE_LINKS.MANAGE_ADDON}`;
    }
    return redirectUrl;
};
